import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_left_button: [
      'close - button1',
      'close - button2',
      'close - button3'
    ],
    multi_right_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3'
    ]
  }
};

const SlideModalImageTracking: FC = () => {
  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center_wrapper {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 16rem;
    }
    .slick-track {
      position: relative;
    }
    .slick_wrapper .slick-list {
      padding: 0 -0.5rem;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      padding: 0 0.5rem;
    }
    .slick_image_box {
      max-width: 16rem;
      min-width: 16rem;
      max-height: 16rem;
      min-height: 16rem;
      outline: 0;
    }
    .slick_image_box img {
      max-width: 16rem;
      min-width: 16rem;
      max-height: 16rem;
      min-height: 16rem;
      object-fit: cover;
    }

    .contents_wrapper {
      margin-top: 1rem;
      width: 100%;
      padding: 0 10%;

      display: flex;
      justify-content: center;
    }
    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      height: 4.5rem;
    }
    .contents_wrapper .slick-slider {
      width: 16rem;
    }

    .contents_box {
      height: 4rem;
    }
    .contents_box .title {
      width: 100%;
      height: 4rem;
      
      display: flex;
      align-items: center;
    }

    .dot_wrapper {
      margin-top: 1rem;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;
    }

    .btn_wrapper {
      width: 100%;
      height: 2rem;

      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
    }
    .btn_inner {
      width: 16rem;
    }
    .btn_wrapper span {
      width: 100%;
    }

    .btn_wrapper .style01 {
        height: 2.5rem;
    }
    .btn_wrapper .style02 {
        height: 2.5rem;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="center_wrapper">
          <div className="slick_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_image?.[currentIndex]}
              type="multi_image"
            />
          </div>
          <div className="contents_wrapper" />
          <div className="btn_wrapper">
            <div className="btn_inner">
              <span className="style01 tracking_center">
                <EditTracking
                  value={tracking?.multi_left_button?.[currentIndex]}
                  type="multi_left_button"
                />
              </span>
              <span className="style02 tracking_center">
                <EditTracking
                  value={tracking?.multi_right_button?.[currentIndex]}
                  type="multi_right_button"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SlideModalImageTracking;
